var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 38,
    viewBox: "0 0 13 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49414 0C8.38216 0 9.92839 0.439453 11.1328 1.31836C12.3535 2.19727 12.9639 3.65397 12.9639 5.68848C12.9639 6.25814 12.915 6.8278 12.8174 7.39746C12.736 7.96712 12.6221 8.52865 12.4756 9.08203L9.42383 20.9473C9.22852 21.7285 8.91113 22.3958 8.47168 22.9492C8.0485 23.4863 7.38932 23.7549 6.49414 23.7549C5.59896 23.7549 4.93164 23.4782 4.49219 22.9248C4.06901 22.3714 3.75977 21.7122 3.56445 20.9473L0.488281 9.08203C0.341797 8.52865 0.219727 7.96712 0.12207 7.39746C0.0406901 6.8278 0 6.25814 0 5.68848C0 3.6377 0.610352 2.18099 1.83105 1.31836C3.05176 0.439453 4.60612 0 6.49414 0ZM6.32324 37.2314C5.2002 37.2314 4.21549 36.9303 3.36914 36.3281C2.52279 35.7259 1.85547 34.9447 1.36719 33.9844C0.895182 33.0241 0.65918 32.015 0.65918 30.957C0.65918 29.8828 0.895182 28.8737 1.36719 27.9297C1.85547 26.9694 2.52279 26.1963 3.36914 25.6104C4.21549 25.0081 5.2002 24.707 6.32324 24.707C7.46257 24.707 8.4554 25.0081 9.30176 25.6104C10.1644 26.1963 10.8398 26.9613 11.3281 27.9053C11.8164 28.8493 12.0605 29.8665 12.0605 30.957C12.0605 32.0312 11.8164 33.0485 11.3281 34.0088C10.8398 34.9528 10.1644 35.7259 9.30176 36.3281C8.43913 36.9303 7.44629 37.2314 6.32324 37.2314Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning_icon.db7363be103aaffc61289908f89d6a31.svg";
export { ForwardRef as ReactComponent };